import React, { FC } from 'react';
import './list-item.css';

type Props = {
    children: any,
    onSelect: (event) => void,
    isSelected: boolean,
    isStripe: boolean,
    className: string,
    checkSelect?: boolean,
    selectedListItemClassName?: string,
    optionalColumns?: any,
    cyName? : string
}

const ListItem: FC<Props> = ({ children, onSelect, isSelected = false, isStripe = false, className = '', checkSelect = false, selectedListItemClassName, cyName}) => {
    let bg = 'bg-white';
    let textColour = '';
    let checked = ''

    if (selectedListItemClassName && isSelected) {
        bg = '';
        textColour = '';
        checked = '';
        className = selectedListItemClassName;
    }
    else if (checkSelect && isSelected) {
        checked = 'checked';
    }
    else if (isSelected) {
        bg = 'bg-portal-blue-primary-shade2';
        textColour = 'text-white';
    } else if (isStripe) {
        bg = 'bg-gray-300';
    }

    return (
        <li data-cy={cyName} id="onSelect" className={`w-full h-auto text-xs cursor-pointer ${textColour} ${bg} ${className} ${checked} `} onClick={onSelect}>
            {children}
        </li>
    );
}

export default ListItem;
